import { Map } from 'immutable';
import { SERIALIZE_ERRORS } from '../actions/diagnostic';
import { TASK_TYPE } from 'saas/constants';

const errors = (state = [], action) => {
  switch (action.type) {
    case SERIALIZE_ERRORS:
      return action.errors;
    default:
      return state;
  }
};

export default errors;

export const getAllErrors = state => {
  const all = state.siteCase.errors;
  // Group them by site
  const grouped = all.reduce((map, item) => {
    if (item.field && item.field === 'site.empty') {
      return map.set(item.field, true);
    } else {
      return map.set(item.site.toString(), true);
    }
  }, Map());
  return grouped;
};

export const getSiteErrors = (state, site) => {
  return state.siteCase.errors.filter(
    e => e.site.toString() === site.toString()
  );
};

export const getDiagnosticErrors = (state, site) => {
  const bySite = getSiteErrors(state, site);

  // Group them by type
  return Map()
    .set(
      TASK_TYPE.RAT,
      bySite.filter(e => e.type === TASK_TYPE.RAT)
    )
    .set(
      TASK_TYPE.INSECT,
      bySite.filter(e => e.type === TASK_TYPE.INSECT)
    )
    .set(
      TASK_TYPE.DISINFECTION,
      bySite.filter(e => e.type === TASK_TYPE.DISINFECTION)
    )
    .set(
      TASK_TYPE.OTHER_PESTS,
      bySite.filter(e => e.type === TASK_TYPE.OTHER_PESTS)
    )
    .set(
      TASK_TYPE.ANNEX1,
      bySite.filter(e => e.type === TASK_TYPE.ANNEX1)
    )
    .set(
      TASK_TYPE.ANNEX2,
      bySite.filter(e => e.type === TASK_TYPE.ANNEX2)
    );
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/reducers/errors.js